<template lang="html">
  <div class="detailed-report text--primary printable">
    <div class="detailed-report-meta">
      Generated at {{now}}
    </div>
    <div class="detailed-report__section">
      <div class="detailed-report__section-title text-center">
        Detailed Report Total
      </div>
      <div class="detailed-report__section-value">
        {{date}}
      </div>
    </div>

    <div class="detailed-report__section">
      <div class="detailed-report__section-title text-center">
        {{orgName}}
      </div>
      <div class="detailed-report__section-value">
        org.nr. {{orgNumber}}
      </div>
    </div>

    <div class="detailed-report__section">
      <div class="detailed-report__section-title">
        Sales by payment method
      </div>
      <div class="detailed-report__section-data">
        <table class="bold-last">
          <thead>
            <tr>
              <th class="text-left">
                Payment Type
              </th>
              <th class="text-left">
                Count
              </th>
              <th class="text-right">
                avg, incl. VAT
              </th>
              <th class="text-right">
                excl. VAT
              </th>
              <th class="text-right">
                incl. VAT
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="byMethod in paymentsByPaymentMethod.byMethod" :key="byMethod.method">
              <td>{{byMethod.method}}</td>
              <td>{{byMethod.payments.length}}</td>
              <td class="right no-break">{{byMethod.amountAverage.toFixed(2)}}&nbsp;SEK</td>
              <td class="right no-break">{{byMethod.amountExclVat.toFixed(2)}}&nbsp;SEK</td>
              <td class="right no-break">{{byMethod.amount.toFixed(2)}}&nbsp;SEK</td>
            </tr>
            <tr>
              <td>Total</td>
              <td>{{paymentsByPaymentMethod.payments.length}}</td>
              <td class="right no-break">{{totalGrossAverage.toFixed(2)}}&nbsp;SEK</td>
              <td class="right no-break">{{totalGrossExclVat.toFixed(2)}}&nbsp;SEK</td>
              <td class="right no-break">{{totalGross.toFixed(2)}}&nbsp;SEK</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div id="payment-methods-chart">
      <apexchart type="pie" width="340" :options="paymentMethodsChart" :series="paymentMethodsChart.series"></apexchart>
    </div>

    <div id="payment-methods-chart">
      <apexchart :options="paymentMethodsChartExclVat" :series="paymentMethodsChartExclVat.series"></apexchart>
    </div>

    <div class="detailed-report__section">
      <div class="detailed-report__section-title">
        Sales by group (net)
      </div>
      <div class="detailed-report__section-data">
        <v-data-table
          dense
          :headers="itemsByGroupHeaders"
          :items="itemsByGroup"
          :hide-default-footer="true"
          disable-pagination
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-xs-right text-left pa-0"> {{ item.itemgroupName }} </td>
              <td class="text-xs-right text-center pa-0"> {{ item.items.length }} </td>
              <td class="text-xs-right text-right pa-0"> {{ item.total.toFixed(2) }} SEK </td>
            </tr>
          </template>
          <template slot="body.append">
            <tr>
              <td class="text-xs-right text-left pa-0 font-weight-bold">Total</td>
              <td class="text-xs-right text-center pa-0 font-weight-bold">{{ items.length }}</td>
              <td class="text-xs-right text-right pa-0 font-weight-bold">{{ items.reduce((a, item) => a + getNet(item.price, item.vat), 0).toFixed(2) }} SEK</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>

    <div class="detailed-report__section">
      <div class="detailed-report__section-title">
        Refunds by group (net)
      </div>
      <div class="detailed-report__section-data">
        <v-data-table
          dense
          :headers="itemsByGroupHeaders"
          :items="refundsByGroup"
          :hide-default-footer="true"
          disable-pagination
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-xs-right text-left pa-0"> {{ item.itemgroupName }} </td>
              <td class="text-xs-right text-center pa-0"> {{ item.items.length }} </td>
              <td class="text-xs-right text-right pa-0"> {{ item.total.toFixed(2) }} SEK </td>
            </tr>
          </template>
          <template slot="body.append">
            <tr>
              <td class="text-xs-right text-left pa-0 font-weight-bold">Total</td>
              <td class="text-xs-right text-center pa-0 font-weight-bold">{{ refunds.length }}</td>
              <td class="text-xs-right text-right pa-0 font-weight-bold">{{ refunds.reduce((a, item) => a + getNet(item.price, item.vat), 0).toFixed(2) }} SEK</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>

    <div class="detailed-report__section">
      <div class="detailed-report__section-title">
        Sales by item (net)
      </div>
      <div class="detailed-report__section-data">
        <v-data-table
          dense
          :headers="itemsByItemHeaders"
          :items="itemsByItem"
          :hide-default-footer="true"
          disable-pagination
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-xs-right text-left pa-0"> {{ item.operatorName }} </td>
              <td class="text-xs-right text-left pa-0"> {{ item.itemgroupName }} </td>
              <td class="text-xs-right text-left pa-0"> {{ item.title }} </td>
              <td class="text-xs-right text-center pa-0"> {{ item.items.length }} </td>
              <td class="text-xs-right text-right pa-0"> {{ item.total.toFixed(2) }} SEK </td>
            </tr>
          </template>
          <template slot="body.append">
            <tr>
              <td class="text-xs-right text-left pa-0 font-weight-bold">Total</td>
              <td></td>
              <td></td>
              <td class="text-xs-right text-center pa-0 font-weight-bold">{{ items.length }}</td>
              <td class="text-xs-right text-right pa-0 font-weight-bold">{{ items.reduce((a, item) => a + getNet(item.price, item.vat), 0).toFixed(2) }} SEK</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>

    <div id="sales-by-item-chart">
      <apexchart
        :options="salesByItemChart"
        :series="salesByItemChart.series"
        :height="salesByItemChart.autoHeight"
        ></apexchart>
    </div>

    <div v-if="tableOrders.show" class="detailed-report__section">
      <div class="detailed-report__section-title">
        Sales by type
      </div>
      <div id="table-orders-chart">
        <apexchart type="pie" width="340" :options="tableOrdersChart" :series="tableOrdersChart.series"></apexchart>
      </div>
    </div>

    <div class="detailed-report__section">
      <div class="detailed-report__section-title">
        Refunds by item (net)
      </div>
      <div class="detailed-report__section-data">
        <v-data-table
          dense
          :headers="itemsByItemHeaders"
          :items="refundsByItem"
          :hide-default-footer="true"
          disable-pagination
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-xs-right text-left pa-0"> {{ item.operatorName }} </td>
              <td class="text-xs-right text-left pa-0"> {{ item.itemgroupName }} </td>
              <td class="text-xs-right text-left pa-0"> {{ item.title }} </td>
              <td class="text-xs-right text-center pa-0"> {{ item.items.length }} </td>
              <td class="text-xs-right text-right pa-0"> {{ item.total.toFixed(2) }} SEK </td>
            </tr>
          </template>
          <template slot="body.append">
            <tr>
              <td class="text-xs-right text-left pa-0 font-weight-bold">Total</td>
              <td></td>
              <td></td>
              <td class="text-xs-right text-center pa-0 font-weight-bold">{{ refunds.length }}</td>
              <td class="text-xs-right text-right pa-0 font-weight-bold">{{ refunds.reduce((a, item) => a + getNet(item.price, item.vat), 0).toFixed(2) }} SEK</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>

    <div class="detailed-report__section">
      <div class="detailed-report__section-title">
        Sales by VAT rate (net)
      </div>
      <div class="detailed-report__section-data">
        <table class="bold-last">
          <thead>
          </thead>
          <tbody>
            <tr v-for="group in itemsByVat" :key="group.vat">
              <td>VAT {{group.vat}}%</td>
              <td class="right no-break">{{group.items.reduce((a, item) => a + getNet(item.price, item.vat), 0).toFixed(2)}}&nbsp;SEK</td>
            </tr>
            <tr>
              <td>Total</td>
              <td class="right no-break">{{totalGrossExclVat.toFixed(2)}}&nbsp;SEK</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="detailed-report__section">
      <div class="detailed-report__section-title">
        Total
      </div>
      <div class="detailed-report__section-data">
        <table class="bold-last">
          <thead>
          </thead>
          <tbody>
            <tr>
              <td>Total net</td>
              <td class="right no-break">{{totalNet.toFixed(2)}}&nbsp;SEK</td>
            </tr>
            <tr v-for="group in totalVats" :key="group.vat">
              <td>VAT {{group.vat}}%</td>
              <td class="right no-break">{{group.amount.toFixed(2)}}&nbsp;SEK</td>
            </tr>
            <tr>
              <td>Total gross</td>
              <td class="right no-break">{{totalGross.toFixed(2)}}&nbsp;SEK</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
  props: {
    payments: {
      type: Array
    },
    date: {
      type: String
    },
    orgName: {
      type: String
    },
    orgNumber: {
      type: String
    }
  },
  data () {
    return {
      itemsByGroupHeaders: [
        { text: 'Group', value: 'itemgroupName' },
        { text: 'Count', align: 'center', value: 'items.length' },
        { text: 'excl. Vat', align: 'right', value: 'total'  }
      ],
      itemsByItemHeaders: [
        { text: 'Operator', value: 'operatorName' },
        { text: 'Group', value: 'itemgroupName' },
        { text: 'Name', value: 'title' },
        { text: 'Count', align: 'center', value: 'items.length' },
        { text: 'excl. Vat', align: 'right', value: 'total'  }
      ],
      chartColors: ['#a00250', '#ffc300', '#bd045f', '#dba800', '#de0771', '#947100', '#fa057e'],
    };
  },
  computed: {
    now () {
      // eslint-disable-next-line no-unused-vars
      var trigger = this.items;
      return moment().format('YYYY-MM-DD HH:mm:ss');
    },
    items () {
      var result = [];
      this.payments.forEach((payment) => {
        var items = payment.items || [];
        items.forEach((item) => {
          item.operatorName = payment.operatorName;
        });
        result = result.concat(items);
      });
      var filteredResult = result.filter(e => e.refunded !== 'True');
      return filteredResult;
    },
    refunds () {
      var result = [];
      this.payments.forEach((payment) => {
        var items = payment.items || [];
        items.forEach((item) => {
          item.operatorName = payment.operatorName;
        });
        result = result.concat(items);
      });
      var filteredResult = result.filter(e => e.refunded === 'True');
      return filteredResult;
    },
    tableOrders () {
      var result = {
        tableOrder: 0,
        noTable: 0,
        show: false
      };
      this.payments.forEach((payment) => {
        if ( typeof payment.tableNumber !== 'undefined' ) {
          result.tableOrder += 1;
        } else {
          result.noTable += 1;
        }
      });
      if ( result.tableOrder > 0 && result.noTable > 0 ) {
        result.show = true;
      }
      return result;
    },
    paymentsByPaymentMethod () {
      var payments = this.payments.slice(0);
      var result = {};
      payments.forEach((payment) => {
        var paymentTypes = payment.paymentType || ['Unknown'];
        var paymentTypeDetails = payment.paymentTypeDetails;
        if (!paymentTypeDetails) {
          paymentTypeDetails = [
            {
              type: paymentTypes[0],
              amount: payment.amount
            }
          ];
        }
        var amountExclVat = 0;
        payment.items.forEach((item) => {
          amountExclVat += this.getNet(item.price, item.vat);
        });
        paymentTypeDetails.forEach(paymentType => {
          var paymentTypeExclVat = amountExclVat * (paymentType.amount / payment.amount);
          if (!(paymentType.type in result)) {
            result[paymentType.type] = {
              count: 0,
              amount: 0,
              amountExclVat: 0,
              amountAverage: 0,
              payments: []
            };
          }
          result[paymentType.type].count += 1;
          result[paymentType.type].amount += paymentType.amount;
          result[paymentType.type].amountExclVat += paymentTypeExclVat;
          result[paymentType.type].amountAverage = (result[paymentType.type].amount) / result[paymentType.type].count;
          result[paymentType.type].payments.push(payment);
        });
      });

      var byMethod = Object.keys(result)
        .sort()
        .map((key) => {
          return {
            method: key,
            ...result[key]
          };
        });
      result = {
        byMethod,
        payments
      };
      return result;
    },
    itemsByGroup () {
      var result = {};
      this.items.forEach((item) => {
        var itemId = item.itemgroupId || 'Unknown';
        if (!(itemId in result)) {
          result[itemId] = [];
        }
        result[itemId].push(item);
      });
      result = Object.keys(result).map((key) => {
        return {
          itemId: result[key][0].itemId,
          itemgroupName: result[key][0].itemgroupName,
          items: result[key],
          total: result[key].reduce((a, item) => a + this.getNet(item.price, item.vat), 0)
        }
      });
      this.sortArrayByKey(result, 'itemgroupName');
      return result;
    },
    refundsByGroup () {
      var result = {};
      this.refunds.forEach((item) => {
        var itemId = item.itemgroupId || 'Unknown';
        if (!(itemId in result)) {
          result[itemId] = [];
        }
        result[itemId].push(item);
      });
      result = Object.keys(result).map((key) => {
        return {
          itemId: result[key][0].itemId,
          itemgroupName: result[key][0].itemgroupName,
          items: result[key],
          total: result[key].reduce((a, item) => a + this.getNet(item.price, item.vat), 0)
        }
      });
      this.sortArrayByKey(result, 'itemgroupName');
      return result;
    },
    itemsByItem () {
      var result = {};
      this.items.forEach((item) => {
        var itemId = item.id || 'Unknown';
        if (itemId.startsWith('custom-amount-')) {
          itemId = [item.title, item.itemgroupId, item.operatorName].join('-');
        } else if (item.subtitle === 'Custom amount') {
          itemId = [item.title, item.itemgroupId, item.operatorName].join('-');
        }
        if (!(itemId in result)) {
          result[itemId] = [];
        }
        result[itemId].push(item);
      });
      result = Object.keys(result).map((key) => {
        return {
          title: result[key][0].title,
          itemId: result[key][0].itemId,
          itemgroupName: result[key][0].itemgroupName,
          operatorName: result[key][0].operatorName,
          items: result[key],
          total: result[key].reduce((a, item) => a + this.getNet(item.price, item.vat), 0)
        }
      });
      this.sortArrayByKey(result, 'title');
      this.sortArrayByKey(result, 'itemgroupName');
      return result;
    },
    refundsByItem () {
      var result = {};
      this.refunds.forEach((item) => {
        var itemId = item.id || 'Unknown';
        if (itemId.startsWith('custom-amount-')) {
          itemId = [item.title, item.itemgroupId, item.operatorName].join('-');
        } else if (item.subtitle === 'Custom amount') {
          itemId = [item.title, item.itemgroupId, item.operatorName].join('-');
        }
        if (!(itemId in result)) {
          result[itemId] = [];
        }
        result[itemId].push(item);
      });
      result = Object.keys(result).map((key) => {
        return {
          title: result[key][0].title,
          itemId: result[key][0].itemId,
          itemgroupName: result[key][0].itemgroupName,
          operatorName: result[key][0].operatorName,
          items: result[key],
          total: result[key].reduce((a, item) => a + this.getNet(item.price, item.vat), 0)
        }
      });
      this.sortArrayByKey(result, 'title');
      this.sortArrayByKey(result, 'itemgroupName');
      return result;
    },
    itemsByVat () {
      var result = {};
      this.items.forEach((item) => {
        var vat = '' + (item.vat || 'Unknown');

        if (!(vat in result)) {
          result[vat] = [];
        }
        result[vat].push(item);
      });
      result = Object.keys(result).map((key) => {
        return {
          vat: result[key][0].vat,
          items: result[key]
        }
      });
      this.sortArrayByKey(result, 'vat');
      return result;
    },

    totalNet () {
      return this.items
        .reduce((a, item) => a + this.getNet(item.price, item.vat), 0);
    },
    totalGross () {
      return this.items.reduce((a, item) => a + item.price, 0);
    },
    totalGrossExclVat () {
      return this.items.reduce((a, item) => a + this.getNet(item.price, item.vat), 0);
    },
    totalGrossAverage () {
      return this.items.reduce((a, item) => a + item.price, 0) / this.paymentsByPaymentMethod.payments.length;
    },
    totalVats () {
      return this.itemsByVat.map((group) => {
        return {
          vat: group.vat,
          amount: group.items.reduce((a, item) => a + this.getVAT(item.price, item.vat), 0)
        };
      });
    },
    paymentMethodsChart () {
      return {
          chart: {
            width: 380,
            type: 'pie'
          },
          colors: this.chartColors,
          labels: this.paymentsByPaymentMethod.byMethod.map(a => a.method),
          series: this.paymentsByPaymentMethod.byMethod.map(a => a.payments.length),
          dataLabels: {
            dropShadow: {
                enabled: true,
                left: 1,
                top: 1,
                blur: 2,
                opacity:0.5
            }
          }
      };
    },
    paymentMethodsChartExclVat () {
      return {
          chart: {
            width: 340,
            type: 'bar'
          },
          colors: this.chartColors,
          series: [
            {
              name: 'Count',
              data: this.paymentsByPaymentMethod.byMethod.map(a => a.payments.length)
            }
          ],
          plotOptions: {
            bar: {
              distributed: true,
              dataLabels: {
                position: 'top'
              }
            }
          },
          dataLabels: {
            dropShadow: {
                enabled: true,
                left: 1,
                top: 1,
                blur: 2,
                opacity:0.5
            }
          },
          xaxis: {
            categories: this.paymentsByPaymentMethod.byMethod.map(a => a.method)
          }
      };
    },
    salesByItemChart () {
      return {
          chart: {
            type: 'bar',
            height: 'auto'
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: true,
            }
          },
          colors: this.chartColors,
          series: [
            {
              name: 'Count',
              data: this.itemsByItem.slice(0).sort(function(a, b) {
                if (a.items.length > b.items.length) return -1;
                if (a.items.length < b.items.length) return 1;
                return 0;
              }).map(a => a.items.length)
            }
          ],
          xaxis: {
            categories: this.itemsByItem.slice(0).sort(function(a, b) {
                if (a.items.length > b.items.length) return -1;
                if (a.items.length < b.items.length) return 1;
                return 0;
              }).map(a => a.title)
          },
          autoHeight: (this.itemsByItem.length * 20) + 100,
          dataLabels: {
            dropShadow: {
                enabled: true,
                left: 1,
                top: 1,
                blur: 2,
                opacity:0.5
            }
          }
      };
    },
    tableOrdersChart () {
      return {
          chart: {
            width: 380,
            type: 'pie'
          },
          colors: this.chartColors,
          labels: ['Table order', 'Take way'],
          series: [this.tableOrders.tableOrder, this.tableOrders.noTable],
          dataLabels: {
            dropShadow: {
                enabled: true,
                left: 1,
                top: 1,
                blur: 2,
                opacity:0.5
            }
          }
      };
    }
  },
  methods: {
    getNet (amount, vat) {
      // Get amount excl. VAT
      return amount / (1 + vat/100.0);
    },
    getVAT (amount, vat) {
      // Get VAT amount
      return this.getNet(amount, vat) * (vat/100.0);
    },
    sortArrayByKey (array, key) {
      array.sort((a, b) => {
        if (a[key] > b[key]) {
          return 1;
        } else if (a[key] < b[key]) {
          return -1;
        }
        return 0;
      });
      return array;
    }
  }
}
</script>

<style lang="scss" scoped>
.detailed-report-meta {
  font-size: 0.8rem;
  margin-bottom: 1.5rem;
}
.detailed-report__section {
  margin-bottom: 1rem;
}
.detailed-report__section-title {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0.2rem;
}
.detailed-report__section-title.text-center {
  text-align: center;
}
.detailed-report__section-value {
  font-size: 0.9rem;
  text-align: center;
}
.detailed-report__section-data {}
.detailed-report__section-data table {
  width: 100%;
}

.detailed-report__section-data table > tbody > tr:not(:last-child) > td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.detailed-report__section-data table > thead > tr > th {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.detailed-report__section-data table td:not(:last-of-type) {
  padding-right: 0.6rem;
}
.detailed-report__section-data table td.right {
  text-align: right;
}
.detailed-report__section-data table td.no-break {
  white-space: nowrap;
}
.detailed-report__section-data table.bold-last tr:last-of-type {
  font-weight: bold;
}
.detailed-report__section:deep(.v-data-table-header th.sortable) {
  padding: 0 3px !important;
  white-space: nowrap;
}
.detailed-report__section:deep(.v-data-table-header span) {
  font-size: 0.875rem;
}
.detailed-report__section:deep(.v-data-table__wrapper td) {
  height: 25px !important;
}
</style>
